import { GraphRelation } from '../../interfaces/visualization.interface';
import { ElementDefinition } from 'cytoscape';

export function mapRelationsToTreeElements(relations: GraphRelation[]): ElementDefinition[] {
  const nodeIds = new Set<string>();
  const childCount = new Map<string, number>(); // source -> number of children
  const parentCount = new Map<string, number>(); // target -> number of parents

  for (const rel of relations) {
    if (!rel.source || !rel.target) continue;
    nodeIds.add(rel.source);
    nodeIds.add(rel.target);
    childCount.set(rel.source, (childCount.get(rel.source) || 0) + 1);
    parentCount.set(rel.target, (parentCount.get(rel.target) || 0) + 1);
  }

  // Root = appears as source but never as target
  const roots = Array.from(nodeIds).filter(id => !parentCount.has(id));

  const elements: ElementDefinition[] = [];

  for (const id of nodeIds) {
    const isRoot = roots.includes(id);
    const isLeaf = !childCount.has(id);

    elements.push({
      group: 'nodes',
      data: {
        id,
        label: id,
        isRoot,
        isLeaf,
        nodeType: isRoot ? 'root' : (isLeaf ? 'leaf' : 'branch')
      }
    });
  }

  relations.forEach((rel, i) => {
    if (!rel.source || !rel.target) return;
    elements.push({
      group: 'edges',
      data: {
        id: `${rel.source}→${rel.target}__${i}`,
        source: rel.source,
        target: rel.target,
        label: rel.relationship || ''
      }
    });
  });

  return elements;
}